import React, { useState } from 'react';

const Contact = () => {
  // State to hold form data
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // State to handle form submission success/error
  const [submissionStatus, setSubmissionStatus] = useState('');

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    // Here you can handle form data, e.g., send it to an API or log it
    console.log('Form data submitted:', formData);
    
    // Simulate form submission success
    setSubmissionStatus('Thank you for your message! We will get back to you soon.');
    
    // Reset form fields
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  return (
    <section className="padding w-full py-12 bg-gray-100 animate-fadeIn" id='contact'>
      <div className="container mx-auto text-center mb-8">
        <h2 className="text-4xl font-bold text-blue-600 mb-4">Get In Touch</h2>
        <p className="text-lg text-gray-600 mb-8">
          Have questions? We’d love to hear from you. Fill out the form below, and we will get back to you shortly!
        </p>
        {submissionStatus && <p className="text-green-500">{submissionStatus}</p>} {/* Submission status message */}
      </div>

      <div className="container mx-auto px-4">
        <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-lg p-8">
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="name">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name" // Set name attribute for state management
                  className="shadow-sm border border-gray-300 rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                  placeholder="Your Name"
                  value={formData.name} // Controlled input
                  onChange={handleChange} // Handle change
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="email">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email" // Set name attribute for state management
                  className="shadow-sm border border-gray-300 rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                  placeholder="Your Email"
                  value={formData.email} // Controlled input
                  onChange={handleChange} // Handle change
                  required
                />
              </div>
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="phone">
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                name="phone" // Set name attribute for state management
                className="shadow-sm border border-gray-300 rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="Your Phone Number"
                value={formData.phone} // Controlled input
                onChange={handleChange} // Handle change
              />
            </div>

            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-medium mb-2" htmlFor="message">
                Message
              </label>
              <textarea
                id="message"
                name="message" // Set name attribute for state management
                rows="5"
                className="shadow-sm border border-gray-300 rounded w-full py-2 px-3 focus:outline-none focus:ring-2 focus:ring-blue-600"
                placeholder="Your Message"
                value={formData.message} // Controlled input
                onChange={handleChange} // Handle change
                required
              ></textarea>
            </div>

            <div className="flex justify-center">
              <button
                type="submit"
                className="bg-blue-600 text-white font-medium py-2 px-4 rounded hover:bg-blue-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
              >
                Send Message
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
